import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface ICoinIconProps extends IconPropsType {}

const CoinIcon = ({ size = 16, ...props }: ICoinIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2110_1433)">
      <circle cx={7.71737} cy={8.49569} r={7.71786} fill="#FFB340" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.71737 14.8243C11.2126 14.8243 14.046 11.9909 14.046 8.49569C14.046 5.00048 11.2126 2.16705 7.71737 2.16705C4.22216 2.16705 1.38873 5.00048 1.38873 8.49569C1.38873 11.9909 4.22216 14.8243 7.71737 14.8243ZM7.71737 16.2135C11.9798 16.2135 15.4352 12.7581 15.4352 8.49569C15.4352 4.23323 11.9798 0.777832 7.71737 0.777832C3.45491 0.777832 -0.000488281 4.23323 -0.000488281 8.49569C-0.000488281 12.7581 3.45491 16.2135 7.71737 16.2135Z"
        fill="url(#paint0_angular_2110_1433)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0463 8.60912C13.8506 12.029 10.9586 14.6849 7.51651 14.5697C4.07519 14.4546 1.36772 11.6127 1.39969 8.18848C1.39679 8.23925 1.39448 8.29019 1.39277 8.3413C1.27589 11.8346 4.01299 14.7611 7.50625 14.878C10.9995 14.9949 13.9261 12.2578 14.043 8.76454C14.0447 8.7126 14.0458 8.66079 14.0463 8.60912Z"
        fill="#FFF5C6"
      />
      <g filter="url(#filter0_d_2110_1433)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1075 8.04212C11.1075 6.34421 9.72906 4.96777 8.0286 4.96777C6.39552 4.96777 5.05914 6.23698 4.95602 7.84458H4.94971V8.04212L4.94971 12.0978L6.66698 10.7991C7.07736 11.003 7.54039 11.1164 8.0286 11.1164C9.72906 11.1164 11.1075 9.74002 11.1075 8.04212ZM7.12168 7.07982H7.23956L8.24762 6.43889C8.26234 6.43047 8.28125 6.43468 8.28967 6.4473C8.29812 6.46201 8.29387 6.48093 8.28125 6.48934L7.35319 7.07982H8.92735C9.09149 7.07982 9.22409 7.21222 9.22409 7.37611V8.53399C9.22409 8.69793 9.09149 8.83028 8.92735 8.83028H7.12378C6.95964 8.83028 6.82704 8.69793 6.82704 8.53399V7.37611C6.82493 7.21222 6.95964 7.07982 7.12168 7.07982ZM9.07711 6.9262C9.23081 6.93462 9.36557 7.04179 9.4098 7.18898C9.41401 7.2058 9.4056 7.22263 9.38872 7.22684C9.37188 7.23105 9.35506 7.22263 9.35085 7.2058C9.31295 7.08175 9.20347 6.99346 9.07291 6.98505C9.05608 6.98505 9.04346 6.97033 9.04346 6.95355C9.04556 6.93672 9.06028 6.9241 9.07711 6.9262ZM9.13374 6.79432H9.0748C9.05796 6.79432 9.04535 6.80695 9.04745 6.82588C9.04745 6.84271 9.06007 6.85528 9.0769 6.85528H9.13585C9.32535 6.85528 9.48115 7.00877 9.48115 7.19798C9.48115 7.2148 9.49381 7.22742 9.51065 7.22742C9.52747 7.22742 9.5401 7.2148 9.5401 7.19798C9.53799 6.97511 9.35695 6.79432 9.13374 6.79432ZM9.0748 6.6554H9.11901C9.41379 6.6554 9.65592 6.8972 9.65592 7.19151V7.19782C9.65592 7.21466 9.64331 7.22727 9.62643 7.22727C9.6096 7.22727 9.59699 7.21466 9.59699 7.19782V7.19151C9.59699 6.93084 9.38219 6.71641 9.12111 6.71641H9.0769C9.06007 6.71641 9.04745 6.70378 9.04745 6.68696C9.04535 6.66802 9.05796 6.6554 9.0748 6.6554Z"
          fill="#FFFAE8"
        />
      </g>
      <g filter="url(#filter1_d_2110_1433)">
        <path
          d="M8.84749 7.39941H8.35059V7.70847H8.84749V7.39941Z"
          fill="#FFFAE8"
        />
      </g>
      <g filter="url(#filter2_d_2110_1433)">
        <path
          d="M8.22267 7.39941H7.16992V7.70847H8.22267V7.39941Z"
          fill="#FFFAE8"
        />
      </g>
      <g filter="url(#filter3_d_2110_1433)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.34694 8.62898C7.42692 8.62898 7.49222 8.56383 7.49222 8.48395C7.49222 8.40402 7.42692 8.33887 7.34694 8.33887C7.26691 8.33887 7.20166 8.40402 7.20166 8.48395C7.20166 8.56383 7.26691 8.62898 7.34694 8.62898Z"
          fill="#FFFAE8"
        />
      </g>
      <g filter="url(#filter4_d_2110_1433)">
        <path
          d="M7.82888 8.63142C7.90911 8.63142 7.97416 8.56647 7.97416 8.48639C7.97416 8.40626 7.90911 8.34131 7.82888 8.34131C7.74865 8.34131 7.68359 8.40626 7.68359 8.48639C7.68359 8.56647 7.74865 8.63142 7.82888 8.63142Z"
          fill="#FFFAE8"
        />
      </g>
      <g filter="url(#filter5_d_2110_1433)">
        <path
          d="M8.76691 8.53512C8.89351 8.40866 8.89351 8.20369 8.76691 8.07723C8.64025 7.95082 8.43497 7.95082 8.30837 8.07723C8.18171 8.20369 8.18171 8.40866 8.30837 8.53512C8.43497 8.66157 8.64025 8.66157 8.76691 8.53512Z"
          fill="#FFFAE8"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_2110_1433"
        x={4.94971}
        y={4.49607}
        width={7.11738}
        height={8.07329}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.487968} />
        <feGaussianBlur stdDeviation={0.235851} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2110_1433"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2110_1433"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2110_1433"
        x={8.28552}
        y={7.30182}
        width={0.692257}
        height={0.504269}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.0325312} />
        <feGaussianBlur stdDeviation={0.0487968} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2110_1433"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2110_1433"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_2110_1433"
        x={7.10486}
        y={7.30182}
        width={1.24792}
        height={0.504269}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.0325312} />
        <feGaussianBlur stdDeviation={0.0487968} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2110_1433"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2110_1433"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_2110_1433"
        x={7.1366}
        y={8.24127}
        width={0.485714}
        height={0.485226}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.0325312} />
        <feGaussianBlur stdDeviation={0.0487968} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2110_1433"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2110_1433"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_2110_1433"
        x={7.61853}
        y={8.24372}
        width={0.485714}
        height={0.485226}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.0325312} />
        <feGaussianBlur stdDeviation={0.0487968} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2110_1433"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2110_1433"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_2110_1433"
        x={8.14832}
        y={7.88483}
        width={0.843625}
        height={0.842648}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.0325312} />
        <feGaussianBlur stdDeviation={0.0487968} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2110_1433"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2110_1433"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_angular_2110_1433"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.71737 8.49569) rotate(-62.9279) scale(7.80076)"
      >
        <stop stopColor="#FFDE47" />
        <stop offset={1} stopColor="#FFE987" />
      </radialGradient>
      <clipPath id="clip0_2110_1433">
        <rect y={0.777832} width={16} height={16} rx={8} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CoinIcon;
